import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useId } from 'react';
import { Input } from '../../components/ui/input';
import { useDebouncedCommit } from './useDebouncedCommit';
const ShadcnTextField = ({ formrValue, onUpdate, readonly = false, debounceMs = 0 }) => {
    // Ties the label to its control, so the field has an accessible name.
    const id = useId();
    const [localValue, setLocalValue] = useState(formrValue.value);
    const isDisabled = readonly || !formrValue.editable(formrValue.value);
    useEffect(() => {
        setLocalValue(formrValue.value);
    }, [formrValue.value]);
    const { schedule, flush, isPending: pendingUpdate } = useDebouncedCommit(debounceMs, (value) => onUpdate(formrValue.key, formrValue.setter(value)));
    const validation = formrValue.validator(formrValue.value);
    const onChange = (event) => {
        const rawValue = event.target.value;
        setLocalValue(rawValue);
        let finalValue = rawValue;
        if (formrValue.type === 'number') {
            if (rawValue === '' || rawValue === '-')
                return;
            const parsed = parseFloat(rawValue);
            finalValue = isNaN(parsed) ? 0 : parsed;
        }
        schedule(finalValue);
    };
    const onBlur = () => {
        // Report a debounced edit now: whatever took focus may act on the value.
        flush();
        if (formrValue.type === 'number') {
            const parsed = parseFloat(String(localValue));
            const finalValue = isNaN(parsed) ? 0 : parsed;
            setLocalValue(finalValue);
            onUpdate(formrValue.key, formrValue.setter(finalValue));
        }
    };
    const showError = !validation.isValid && !pendingUpdate;
    return (_jsxs("div", { className: "space-y-1", children: [_jsx("label", { htmlFor: id, className: "text-sm font-medium text-foreground", children: formrValue.label }), _jsx(Input, { id: id, autoFocus: formrValue.autoFocus, type: formrValue.type === 'number' ? 'number' : 'text', value: localValue ?? '', name: formrValue.key, onChange: onChange, onBlur: onBlur, onKeyDown: (ev) => {
                    if (ev.key === 'Enter')
                        ev.preventDefault();
                }, disabled: isDisabled, "aria-invalid": showError }), showError && (_jsx("p", { className: "text-sm text-destructive", children: validation.message }))] }));
};
export { ShadcnTextField };
//# sourceMappingURL=ShadcnTextField.js.map